import { KeycloakAuthHttp } from '@elotech/angular-common';
import { ServidorSelecionadoService } from './../components/funcionario-sidebar/servidor-selecionado.service';
import { FuncionarioService } from './../../../../folha-pagamento/src/funcionario/funcionario.service';
import { Injectable } from '@angular/core';

@Injectable()
export class MatriculaSidebarService {

  private matriculas = [];
  private userInfo;

  constructor(
    private funcionarioService: FuncionarioService,
    private servidorSelecionadoService: ServidorSelecionadoService,
    private keycloak: KeycloakAuthHttp
  ) { }

  public async setMatriculas(usuario) {
    this.matriculas = await this.funcionarioService.findFuncionariosPorCpf(usuario['preferred_username']).toPromise();
  }

  public setUserInfo(usuario) {
    this.userInfo = usuario;
  }

  public getUserInfo() {
    return this.userInfo;
  }

  public getMatriculas() {
    return this.matriculas;
  }

  public definirServidorSelecionado(funcionario) {
    if (funcionario) {
      this.servidorSelecionadoService.salvarFuncionarioSelecionado(funcionario);
    }
  }

  public changeMatricula(userInfo, funcionario) {
    userInfo.entidadePadrao = userInfo.entidades.find(e => e.id === funcionario.entidade);
    this.keycloak.setUsuarioInfo(userInfo);
    this.definirServidorSelecionado(funcionario);
  }

  public findFuncionarios() {
    const funcionarioLigado = this.getFuncionarioMenorMatricula(this.matriculas, f => !f.dataDesligamento);
    const funcionarioDesligado = this.getFuncionarioMenorMatricula(this.matriculas, f => f.dataDesligamento);

    return funcionarioLigado || funcionarioDesligado;
  }

  private getFuncionarioMenorMatricula(funcionarios, filter) {
    return funcionarios.filter(filter)
      .sort(this.ordernarPorMatricula)
      .shift();
  }

  private ordernarPorMatricula(a, b) {
    return a.matricula - b.matricula;
  }
}
